module.exports = __webpack_public_path__ + "arrow_up.60da33ab.jpg";